module.exports = __webpack_public_path__ + "img/head.5a03a0fe.png";